import React from 'react';

import {
  useTranslation,
} from 'react-i18next';

import {
  useSelector,
  useDispatch,
} from 'react-redux';

import {
  IInputSelect,
} from '@noitada/axios-config/interfaces/App/input-select.interface';

import {
  RootState,
} from '@noitada/redux-config';

import {
  MODAL_LOCATION_APP_ACTION,
} from '@noitada/redux-config/reducers/localities.store';

import {
  Colors,
} from '@noitada/shared/constants';

import {
  TranslateConfig,
} from '@noitada/shared/translations';

import {
  returnCityArray,
  returnStateArray,
} from '@noitada/shared/utils/address.utils';

import {
  IconMapLocation,
} from '../../Icons';

import {
  ButtonCityUserStyle,
  ButtonCityView,
  ButtonCityParent,
  MenuIconCity,
  MenuTextCity,
} from './styled';



const ButtonCityUser: React.FC = () => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();


  const localities = useSelector((state: RootState) => state.localities.selected);

  const getStateArray = returnStateArray(localities?.country);
  const findState = getStateArray?.find((itemTravel: IInputSelect) => itemTravel.value === localities?.state);

  const getCityArray = returnCityArray(localities?.country, findState?.value);
  const findCity = getCityArray?.find((itemTravel: IInputSelect) => itemTravel.value === localities?.city);



  return (

    <ButtonCityUserStyle
      onClick={() => {
        dispatch({ type: MODAL_LOCATION_APP_ACTION, payload: true });
      }}>

      <ButtonCityView>

        <ButtonCityParent>
          <MenuIconCity>
            <IconMapLocation
              size={19}
              color={Colors.white}
            />
          </MenuIconCity>


          {/* // FIXME: Se o nome da cidade usar tail (...) fazer o nome se mexer para mostrar todo */}
          <MenuTextCity>
            {findCity?.label || translate(TranslateConfig.CITY)}
          </MenuTextCity>
        </ButtonCityParent>

      </ButtonCityView>

    </ButtonCityUserStyle>

  );
};



export default ButtonCityUser;
